import { useQuery } from "@tanstack/react-query";
import { forexService } from "../api/services/forex/forexService";

const FOREX_STALE_TIME = Number(
  process.env.REACT_APP_FOREX_STALE_TIME || 300000,
);
const FOREX_GC_TIME = Number(process.env.REACT_APP_FOREX_GC_TIME || 600000);

export const useForexRates = () => {
  return useQuery({
    queryKey: ["forex", "rates"],
    queryFn: forexService.getAllRates,
    staleTime: FOREX_STALE_TIME,
    gcTime: FOREX_GC_TIME,
  });
};

export const useForexRate = (currency: string) => {
  return useQuery({
    queryKey: ["forex", "rate", currency],
    queryFn: () => forexService.getRateByCurrency(currency),
    enabled: !!currency,
    staleTime: FOREX_STALE_TIME,
    gcTime: FOREX_GC_TIME,
  });
};
